// @flow

import React, { Fragment } from 'react';
import moment from 'moment';
import map from 'lodash/fp/map';
import flow from 'lodash/fp/flow';
import reduce from 'lodash/fp/reduce';
import split from 'lodash/fp/split';
import TimeInput from 'components/TimeInput/TimeInput';
import L10nMessage from 'react-aaui/lib/shared/L10nMessage';
import { formatedDuration } from 'services/format/formatDuration';
import type { Time } from 'type/type';

type Props = {
  highlightError: boolean,
  finishTime: Array<{
    name: string,
    time: Time,
  }>,
  onFinishTimeChange: (name: string, time: Time) => void
}

const mapWithIndex = map.convert({ cap: false });

const timeToDuration = ({ hour, minutes, seconds }: Time) => moment.duration(`${hour || ''}:${minutes || ''}:${seconds || ''}`);

const calculateTotal = (timeCollection: Array<Time>) => flow(
  map(timeToDuration),
  reduce((prev, next) => prev.add(next), moment.duration('0:0:0')),
)(timeCollection);

const getSplitedTotal = (timeCollection: Array<Time>) => {
  const totalDuration = calculateTotal(timeCollection);

  return flow(
    formatedDuration,
    split(':'),
  )(totalDuration.toISOString());
};

const FinishTimeInput = ({
  highlightError,
  finishTime,
  onFinishTimeChange,
}: Props) => (
  <Fragment>
    {map(({ name, time }) => (
      <Fragment key={name}>
        {finishTime.length > 1 && (
          <div className="virtual-event__submit-result__submit__finish-time__detail__label">
            <L10nMessage id={`global.sportsType.multiStage.${name}`} />
          </div>
        )}
        <TimeInput
          validateEmpty={highlightError}
          maxHour={999}
          time={time}
          onChange={value => onFinishTimeChange(name, value)} />
      </Fragment>
    ))(finishTime)}
    {finishTime.length > 1 && (
      <div className="virtual-event__submit-result__submit__finish-time__detail--total">
        <div className="virtual-event__submit-result__submit__finish-time__detail__label">
          Total
        </div>
        <div className="virtual-event__submit-result__submit__finish-time__detail--total__content">
          {flow(
            map(({ time }) => time),
            getSplitedTotal,
            mapWithIndex((field, index) => (
              <Fragment key={index}>
                <div className="virtual-event__submit-result__submit__finish-time__detail--total__item">
                  {field}
                </div>
                {index !== 2 && (
                  <div className="time-input__separator">:</div>
                )}
              </Fragment>
            )),
          )(finishTime)}
        </div>
      </div>
    )}
  </Fragment>
);

export default FinishTimeInput;
